import { createFileRoute } from '@tanstack/react-router';
import Attendance from 'src/pages/Organization/Branches/Attendance';

export const Route = createFileRoute(
  '/$organizationSlug/branches/$branchId/attendance',
)({
  component: Attendance,
});
